import Chip from "@mui/material/Chip";

// Gatilhos que o servidor REALMENTE dispara (levantamento no código do
// backend em 04/08/2026: users.service, auth.service e feedbacks.service;
// NEW_ACCOUNT_MEMBER_ADMIN implementado em 07/08/2026 — TODO item 12).
// O campo trigger é ÚNICO no banco — um template por gatilho; templates
// com outros valores ficam guardados mas nunca são enviados.
export const mailTriggers: Record<
  string,
  { label: string; description: string }
> = {
  NEW_ACCOUNT_MEMBER: {
    label: "Boas-vindas ao sócio",
    description:
      "Enviado ao e-mail do sócio quando a conta recebe a matrícula.",
  },
  NEW_ACCOUNT_MEMBER_ADMIN: {
    label: "Aviso de conta nova (administração)",
    description:
      "Avisa o e-mail da administração a cada conta nova criada — o nome e o e-mail de quem se cadastrou são anexados ao final do corpo automaticamente.",
  },
  ACCOUNT_RECOVERY: {
    label: "Recuperação de senha",
    description:
      'Enviado ao sócio que pediu "esqueci a senha" — o servidor anexa o link de recuperação ao final do corpo automaticamente.',
  },
  NEW_CONTACT_MESSAGE: {
    label: "Novo contato recebido",
    description:
      "Avisa o e-mail da administração quando chega mensagem pelo formulário de Contato.",
  },
};

// Badge do gatilho: nome amigável quando o servidor o dispara; o código
// técnico cru (em cinza) quando não há disparo. Tooltip sempre mostra o
// código gravado.
export const TriggerChip = ({ trigger }: { trigger?: string | null }) => {
  if (!trigger) return null;
  const known = mailTriggers[String(trigger)];
  return (
    <Chip
      size="small"
      variant="outlined"
      color={known ? "primary" : "default"}
      label={known ? known.label : String(trigger)}
      title={String(trigger)}
    />
  );
};
